import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
} from '@blocksuite/store';

export type DatabaseViewRefProps = {
  /**
   * Id of the doc that holds the source database. Empty means "same doc".
   */
  sourceDocId: string;
  /**
   * Block id of the source `affine:database`.
   */
  sourceBlockId: string;
  /**
   * Id of the view inside the source database to render. Empty renders the
   * default (first) view.
   */
  viewId: string;
  caption: string;
  comments?: Record<string, boolean>;
};

export class DatabaseViewRefBlockModel extends BlockModel<DatabaseViewRefProps> {}

export const DatabaseViewRefBlockSchema = defineBlockSchema({
  flavour: 'affine:database-view-ref',
  props: (): DatabaseViewRefProps => ({
    sourceDocId: '',
    sourceBlockId: '',
    viewId: '',
    caption: '',
    comments: undefined,
  }),
  metadata: {
    version: 1,
    role: 'content',
    parent: ['affine:note', 'affine:column'],
  },
  toModel: () => new DatabaseViewRefBlockModel(),
});

export const DatabaseViewRefBlockSchemaExtension = BlockSchemaExtension(
  DatabaseViewRefBlockSchema
);
